<template>
  <div class="announce_bg" v-if="showAnnounce">
      <svg aria-hidden="true" class="icon common_close" @click="close">
        <use xlink:href="#icon-close"></use>
      </svg>
     <a @click="toHuazhiUrl('invest_islogin')" class="announceBtn">立即体验</a>
  </div>
</template>
<script>
import { mapState } from "vuex";
import toHuazhiUrl from "@/mixins/toHuazhiUrlMixins.js"
export default {
  name: 'Announce',
  data(){
    return{
      showAnnounce: true
    }
  },
  computed: {
    ...mapState(["isLogged"]),
  },
  mixins: [toHuazhiUrl],
  methods:{
    close(){
      this.showAnnounce = false
    },
  }
};
</script>
<style scoped lang="scss">
.announce_bg{
  width: 380px;
  height: 340px;
  position: fixed;
  bottom: 3px;
  right: 3px;
  z-index: 2;
  background: url(../assets/images/temporary/idocAnnounce.png) no-repeat;
  .announceBtn{
    position: absolute;
    bottom: 25px;
    width: 255px;
    height: 60px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
}
</style>